import MDButton from "components/MDButton";
import ActionConfirmDialog from "components/ActionConfirmDialog/ActionConfirmDialog";
import useDeleteProductGroup from "hooks/products/useDeleteProductGroup";
import useConfirmationDialog from "hooks/useConfirmationDialog";
import { useCallback } from "react";

interface DeleteProductGroupProps {
  id: string;
  name: string;
}

export default function DeleteProductGroup({ id, name }: DeleteProductGroupProps) {
  const [deleteProductGroup, { isSuccess }] = useDeleteProductGroup();

  const acceptFn = useCallback(async (): Promise<boolean> => {
    const { data } = await deleteProductGroup({ variables: { id } });
    return isSuccess(data);
  }, [deleteProductGroup, id, isSuccess]);

  const cancelFn = useCallback(async () => {
    return true;
  }, []);

  const { open, setOpen, onAccept, onCancel } = useConfirmationDialog({
    acceptFn,
    cancelFn,
  });

  return (
    <>
      <ActionConfirmDialog
        open={open}
        setOpen={setOpen}
        handleAccept={onAccept}
        handleCancel={onCancel}
        title="Confirmation"
        content={`Are you sure you want to delete the product group "${name}"?`}
        acceptText="Delete"
        cancelText="Cancel"
      />
      <MDButton size="small" variant="text" color="error" onClick={() => setOpen(true)}>
        Delete
      </MDButton>
    </>
  );
}
